import { BigNumberish } from 'ethers';
import { config } from '../config';

export const SubgraphActionMapper: Record<Position['status'], string> = {
    ADDED_MARGIN: 'Deposit Collateral',
    CLOSED: 'Closed Position',
    EXTENDED: 'Increase Size',
    EXTENDED_TO_LEVERAGE: 'Adjust Leverage',
    LIQUIDATED: 'Liquidated',
    OPENED: 'Open Position',
    PARTIALLY_CLOSED: 'Closed Partially',
    REMOVED_MARGIN: 'Withdraw Collateral',
};

export const subgraphTimeframeMapper: Record<
    (typeof config.areaChartTimeframes)[number],
    string
> = {
    '1d': 'DAILY',
    '1m': 'MONTHLY',
    '1w': 'WEEKLY',
    '1y': 'YEARLY',
};

export type SubgraphMeta = {
    deployment: string;
    hasIndexingErrors: boolean;
    block: {
        hash: string;
        number: number;
        timestamp: number;
    };
};

export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
    [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string | number; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    BigDecimal: { input: BigNumberish; output: BigNumberish };
};

export type Platform = {
    __typename?: 'Platform';
    id: Scalars['ID']['output'];
    totalTradesCount: Scalars['BigDecimal']['output'];
    tradersCount: Scalars['BigDecimal']['output'];
    referrersCount: Scalars['BigDecimal']['output'];
    tradePairsCount: Scalars['BigDecimal']['output'];
    priceFeedsCount: Scalars['BigDecimal']['output'];
    protocolFees: Array<ProtocolFee>;
};

export type User = {
    __typename?: 'User';
    id: Scalars['ID']['output'];
    firstTradedTimestamp: Scalars['Int']['output'];
    lastInteractionTimestamp: Scalars['Int']['output'];
    userLiquidityPool: Array<UserLiquidityPool>;
    traders: Array<Trader>;
    positionTransactions: Array<PositionTransaction>;
    deposits: Array<UserDeposit>;
    referrerUser?: Maybe<User>;
    referrals: Array<User>;
    referrerRegistrationTimestamp?: Maybe<Scalars['Int']['output']>;
    customReferralFee: Scalars['BigDecimal']['output'];
    totalReferrerFeeAmount: Scalars['BigDecimal']['output'];
    totalReferrerVolume: Scalars['BigDecimal']['output'];
    totalReferralFeeAmount: Scalars['BigDecimal']['output'];
    totalReferralVolume: Scalars['BigDecimal']['output'];
    referrerFeeTransfers?: Maybe<Array<ReferrerFeeTransfer>>;
    referralFeeTransfers?: Maybe<Array<ReferrerFeeTransfer>>;
    lastReferrerFeeTransfer?: Maybe<ReferrerFeeTransfer>;
    dataMapping: DataMapping;
    positions: Array<Position>;
    trades: Array<Trade>;
};

export type Trader = {
    __typename?: 'Trader';
    id: Scalars['ID']['output'];
    user: User;
    asset: Asset;
    totalVolume: Scalars['BigDecimal']['output'];
    totalSize: Scalars['BigDecimal']['output'];
    totalMargin: Scalars['BigDecimal']['output'];
    totalOpenMargin: Scalars['BigDecimal']['output'];
    totalClosedMargin: Scalars['BigDecimal']['output'];
    whiteLabel?: Maybe<WhiteLabel>;
    wins: Scalars['Int']['output'];
    losses: Scalars['Int']['output'];
    realizedPnL: Scalars['BigDecimal']['output'];
    realizedPnLPercentage: Scalars['BigDecimal']['output'];
    topTrade: Trade;
    positions: Array<Position>;
    trades: Array<Trade>;
};

export type Trade = {
    __typename?: 'Trade';
    id: Scalars['ID']['output'];
    txHash: Scalars['String']['output'];
    tradeIndex: Scalars['Int']['output'];
    timestamp: Scalars['Int']['output'];
    trader: Trader;
    user: User;
    tradePair: TradePair;
    status: Scalars['String']['output'];
    type: Scalars['String']['output'];
    entryMargin: Scalars['BigDecimal']['output'];
    entryPrice: Scalars['BigDecimal']['output'];
    volume: Scalars['BigDecimal']['output'];
    closePrice: Scalars['BigDecimal']['output'];
    blockNumber?: Maybe<Scalars['BigDecimal']['output']>;
    positionId?: Maybe<Scalars['String']['output']>;
    positionTransaction?: Maybe<PositionTransaction>;
    PnL: Scalars['BigDecimal']['output'];
    percentagePnL: Scalars['BigDecimal']['output'];
    grossPnL: Scalars['BigDecimal']['output'];
    percentageGrossPnL: Scalars['BigDecimal']['output'];
    borrowFeePnL: Scalars['BigDecimal']['output'];
    fundingFeePnL: Scalars['BigDecimal']['output'];
    totalFeePnL: Scalars['BigDecimal']['output'];
    percentageFeePnL: Scalars['BigDecimal']['output'];
    borrowFee: Scalars['BigDecimal']['output'];
    fundingFee: Scalars['BigDecimal']['output'];
};

export type Warning = {
    __typename?: 'Warning';
    id: Scalars['ID']['output'];
    tradePair: TradePair;
    timestamp: Scalars['Int']['output'];
    amount?: Maybe<Scalars['BigDecimal']['output']>;
    type: Scalars['String']['output'];
};

export type Asset = {
    __typename?: 'Asset';
    id: Scalars['ID']['output'];
    symbol?: Maybe<Scalars['String']['output']>;
    name?: Maybe<Scalars['String']['output']>;
    decimals: Scalars['BigDecimal']['output'];
    liquidity: Scalars['BigDecimal']['output'];
    tradingVolume: Scalars['BigDecimal']['output'];
    protocolFees: ProtocolFee;
    liquidityPools: Array<LiquidityPool>;
};

export type Updatable = {
    __typename?: 'Updatable';
    id: Scalars['ID']['output'];
    active: Scalars['Boolean']['output'];
};

export type LiquidityPool = {
    __typename?: 'LiquidityPool';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    symbol: Scalars['String']['output'];
    totalValueLocked: Scalars['BigDecimal']['output'];
    totalDeposits: Scalars['BigDecimal']['output'];
    totalWithdrawals: Scalars['BigDecimal']['output'];
    totalSupply: Scalars['BigDecimal']['output'];
    currentPriceEstimate: Scalars['BigDecimal']['output'];
    currentLPPriceEstimate: Scalars['BigDecimal']['output'];
    totalFeeAmount: Scalars['BigDecimal']['output'];
    totalPnL: Scalars['BigDecimal']['output'];
    historicalApr: Scalars['BigDecimal']['output'];
    decimals: Scalars['BigDecimal']['output'];
    assetDecimals: Scalars['BigDecimal']['output'];
    earlyWithdrawalFee: Scalars['BigDecimal']['output'];
    earlyWithdrawalTime: Scalars['BigDecimal']['output'];
    defaultLockTime: Scalars['BigDecimal']['output'];
    asset: Asset;
    lockPools: Array<LockPool>;
    liquidityPoolAdapters: Array<LiquidityPoolAdapterConfig>;
    periodData: Array<LiquidityPoolData>;
    active: Scalars['Boolean']['output'];
    dataMapping: DataMapping;
};

export type DataMapping = {
    __typename?: 'DataMapping';
    id: Scalars['ID']['output'];
    data: Array<Data>;
};

export type UserLiquidityPool = {
    __typename?: 'UserLiquidityPool';
    id: Scalars['ID']['output'];
    user: User;
    assets: Scalars['BigDecimal']['output'];
    shares: Scalars['BigDecimal']['output'];
    totalDeposits: Scalars['BigDecimal']['output'];
    totalWithdrawals: Scalars['BigDecimal']['output'];
    totalDepositsShares: Scalars['BigDecimal']['output'];
    totalWithdrawalsShares: Scalars['BigDecimal']['output'];
    liquidityPool: LiquidityPool;
    lastDeposit: Scalars['BigDecimal']['output'];
    deposits: Array<UserDeposit>;
};

export type UserDeposit = {
    __typename?: 'UserDeposit';
    id: Scalars['ID']['output'];
    txHash: Scalars['String']['output'];
    userLiquidityPool: UserLiquidityPool;
    user: User;
    timestamp: Scalars['Int']['output'];
    assets: Scalars['BigDecimal']['output'];
    shares: Scalars['BigDecimal']['output'];
    lockPool?: Maybe<LockPool>;
    poolShares?: Maybe<Scalars['BigDecimal']['output']>;
};

export type LockPool = {
    __typename?: 'LockPool';
    id: Scalars['ID']['output'];
    liquidityPool: LiquidityPool;
    index: Scalars['Int']['output'];
    lockTime: Scalars['BigDecimal']['output'];
    multiplier: Scalars['BigDecimal']['output'];
};

export type LpShares = {
    __typename?: 'LPShares';
    id: Scalars['ID']['output'];
    userLiquidityPool: UserLiquidityPool;
    timestamp: Scalars['Int']['output'];
    amount: Scalars['BigDecimal']['output'];
    assetAmount: Scalars['BigDecimal']['output'];
};

export type Locker = {
    __typename?: 'Locker';
    id: Scalars['ID']['output'];
    locked: Scalars['BigDecimal']['output'];
    unlocked: Scalars['BigDecimal']['output'];
    total: Scalars['BigDecimal']['output'];
};

export type FeeManager = {
    __typename?: 'FeeManager';
    id: Scalars['ID']['output'];
    referralFeeSize: Scalars['BigDecimal']['output'];
    stakersFeeCollection: Scalars['String']['output'];
    devFeeCollection: Scalars['String']['output'];
    insuranceFundFeeCollection: Scalars['String']['output'];
    whiteLabelFeeSizes: Array<WhiteLabelFeeSize>;
};

export type WhiteLabelFeeSize = {
    __typename?: 'WhiteLabelFeeSize';
    id: Scalars['ID']['output'];
    feeSize: Scalars['BigDecimal']['output'];
    feeManager: FeeManager;
};

export type ProtocolFee = {
    __typename?: 'ProtocolFee';
    id: Scalars['ID']['output'];
    platform: Scalars['BigDecimal']['output'];
    total: Scalars['BigDecimal']['output'];
    staker: Scalars['BigDecimal']['output'];
    dev: Scalars['BigDecimal']['output'];
    insuranceFund: Scalars['BigDecimal']['output'];
    liquidityPool: Scalars['BigDecimal']['output'];
    whiteLabel: Scalars['BigDecimal']['output'];
    referrer: Scalars['BigDecimal']['output'];
    hourly: Array<HourlyProtocolFee>;
};

export type HourlyProtocolFee = {
    __typename?: 'HourlyProtocolFee';
    id: Scalars['ID']['output'];
    protocolFee: ProtocolFee;
    timestamp: Scalars['Int']['output'];
    total: Scalars['BigDecimal']['output'];
    net: Scalars['BigDecimal']['output'];
};

export type ReferrerFeeTransfer = {
    __typename?: 'ReferrerFeeTransfer';
    id: Scalars['ID']['output'];
    timestamp: Scalars['Int']['output'];
    user: User;
    referrerUser: User;
    asset: Asset;
    amount: Scalars['BigDecimal']['output'];
    volume: Scalars['BigDecimal']['output'];
    transactionHash: Scalars['String']['output'];
};

export type WhiteLabel = {
    __typename?: 'WhiteLabel';
    id: Scalars['ID']['output'];
    tradersCount: Scalars['BigDecimal']['output'];
    firstReferredTimestamp: Scalars['Int']['output'];
    feeSize: Scalars['BigDecimal']['output'];
    assetFees: Array<WhiteLabelFees>;
    traders: Array<Trader>;
};

export type WhiteLabelFees = {
    __typename?: 'WhiteLabelFees';
    id: Scalars['ID']['output'];
    whiteLabel: WhiteLabel;
    asset: Asset;
    feesCollected: Scalars['BigDecimal']['output'];
};

export type TradePair = {
    __typename?: 'TradePair';
    id: Scalars['ID']['output'];
    name: Scalars['String']['output'];
    assetDecimals: Scalars['BigDecimal']['output'];
    collateral: Asset;
    liquidityPoolAdapter: LiquidityPoolAdapter;
    priceFeedAdapter: PriceFeedAdapter;
    active: Scalars['Boolean']['output'];
    positions: Array<Position>;
    borrowFeeRate: Scalars['BigDecimal']['output'];
    maxFundingFeeRate: Scalars['BigDecimal']['output'];
    maxExcessRatio: Scalars['BigDecimal']['output'];
    liquidatorReward: Scalars['BigDecimal']['output'];
    minLeverage: Scalars['BigDecimal']['output'];
    maxLeverage: Scalars['BigDecimal']['output'];
    minMargin: Scalars['BigDecimal']['output'];
    volumeLimit: Scalars['BigDecimal']['output'];
    feeBufferFactor: Scalars['BigDecimal']['output'];
    totalAssetAmountLimit: Scalars['BigDecimal']['output'];
    dataMapping: DataMapping;
};

export type FeeIntegral = {
    __typename?: 'FeeIntegral';
    id: Scalars['ID']['output'];
    borrowFee: Scalars['BigDecimal']['output'];
    longFundingFee: Scalars['BigDecimal']['output'];
    shortFundingFee: Scalars['BigDecimal']['output'];
};

export type LiquidityPoolAdapter = {
    __typename?: 'LiquidityPoolAdapter';
    id: Scalars['ID']['output'];
    active: Scalars['Boolean']['output'];
    liquidityPools: Array<LiquidityPoolAdapterConfig>;
    tradePairs: Array<TradePair>;
};

export type LiquidityPoolAdapterConfig = {
    __typename?: 'LiquidityPoolAdapterConfig';
    id: Scalars['ID']['output'];
    liquidityPool: LiquidityPool;
    percentage: Scalars['BigDecimal']['output'];
    liquidityPoolAdapter: LiquidityPoolAdapter;
};

export type PriceFeedAdapter = {
    __typename?: 'PriceFeedAdapter';
    id: Scalars['ID']['output'];
    active: Scalars['Boolean']['output'];
};

export type Position = {
    __typename?: 'Position';
    id: Scalars['ID']['output'];
    tradePair: TradePair;
    index: Scalars['Int']['output'];
    user: User;
    trader: Trader;
    liquidator: User;
    realizedPnL: Scalars['BigDecimal']['output'];
    lastRealizedPnL: Scalars['BigDecimal']['output'];
    lastRealizedBorrowFee: Scalars['BigDecimal']['output'];
    lastRealizedFundingFee: Scalars['BigDecimal']['output'];
    lastClosedVolume?: Maybe<Scalars['BigDecimal']['output']>;
    margin: Scalars['BigDecimal']['output'];
    volume: Scalars['BigDecimal']['output'];
    size: Size;
    type: Scalars['String']['output'];
    status: Scalars['String']['output'];
    openedTimestamp: Scalars['Int']['output'];
    closedTimestamp: Scalars['Int']['output'];
    liquidatedTimestamp: Scalars['Int']['output'];
    lastActionTimestamp: Scalars['Int']['output'];
    entryMargin: Scalars['BigDecimal']['output'];
    closePrice: Scalars['BigDecimal']['output'];
    entryPrice: Scalars['BigDecimal']['output'];
    signatureHash?: Maybe<Scalars['String']['output']>;
    lastProtocolFeeAmount: Scalars['BigDecimal']['output'];
    lastProtocolFeeTxHash: Scalars['String']['output'];
    positionTransactions: Array<PositionTransaction>;
};

export type Size = {
    __typename?: 'Size';
    id: Scalars['ID']['output'];
    total: Scalars['BigDecimal']['output'];
    poolSplit: Array<PoolSplit>;
};

export type PoolSplit = {
    __typename?: 'PoolSplit';
    id: Scalars['ID']['output'];
    liquidityPool: LiquidityPool;
    active: Scalars['Boolean']['output'];
    amount: Scalars['BigDecimal']['output'];
};

export type Transaction = {
    __typename?: 'Transaction';
    id: Scalars['ID']['output'];
    trades: Scalars['Int']['output'];
};

export type PositionTransaction = {
    __typename?: 'PositionTransaction';
    id: Scalars['ID']['output'];
    txHash: Scalars['String']['output'];
    position: Position;
    user: User;
    transactionType: Scalars['String']['output'];
    timestamp: Scalars['Int']['output'];
    feeAmount: Scalars['BigDecimal']['output'];
    entryMarginBefore: Scalars['BigDecimal']['output'];
    entryMarginAfter: Scalars['BigDecimal']['output'];
    marginBefore: Scalars['BigDecimal']['output'];
    marginAfter: Scalars['BigDecimal']['output'];
    volumeBefore: Scalars['BigDecimal']['output'];
    volumeAfter: Scalars['BigDecimal']['output'];
    entryPriceBefore: Scalars['BigDecimal']['output'];
    entryPriceAfter: Scalars['BigDecimal']['output'];
    entryLeverageBefore: Scalars['BigDecimal']['output'];
    entryLeverageAfter: Scalars['BigDecimal']['output'];
    leverageBefore: Scalars['BigDecimal']['output'];
    leverageAfter: Scalars['BigDecimal']['output'];
    trade?: Maybe<Trade>;
};

export enum PeriodType {
    Hourly = 'HOURLY',
    Daily = 'DAILY',
    Weekly = 'WEEKLY',
    Monthly = 'MONTHLY',
    Yearly = 'YEARLY',
    Total = 'TOTAL',
}

export type DataPoint = {
    __typename?: 'DataPoint';
    id: Scalars['ID']['output'];
    periodType: PeriodType;
    startTimestamp: Scalars['Int']['output'];
    longPositions: Scalars['BigDecimal']['output'];
    longPositionsTotal: Scalars['BigDecimal']['output'];
    shortPositions: Scalars['BigDecimal']['output'];
    shortPositionsTotal: Scalars['BigDecimal']['output'];
    closedPositions: Scalars['BigDecimal']['output'];
    closedPositionsTotal: Scalars['BigDecimal']['output'];
    longVolume: Scalars['BigDecimal']['output'];
    longVolumeTotal: Scalars['BigDecimal']['output'];
    shortVolume: Scalars['BigDecimal']['output'];
    shortVolumeTotal: Scalars['BigDecimal']['output'];
    activeUsers: Scalars['BigDecimal']['output'];
    activeUsersTotal: Scalars['BigDecimal']['output'];
    totalValueLocked: Scalars['BigDecimal']['output'];
    totalValueLockedTotal: Scalars['BigDecimal']['output'];
    tradingVolume: Scalars['BigDecimal']['output'];
    tradingVolumeTotal: Scalars['BigDecimal']['output'];
    protocolFee: Scalars['BigDecimal']['output'];
    protocolFeeTotal: Scalars['BigDecimal']['output'];
    trades: Scalars['BigDecimal']['output'];
    tradesTotal: Scalars['BigDecimal']['output'];
    traders: Array<TraderData>;
    liquidityPools: Array<LiquidityPoolData>;
};

export type TraderData = {
    __typename?: 'TraderData';
    id: Scalars['ID']['output'];
    dataPoint: DataPoint;
    volume: Scalars['BigDecimal']['output'];
    volumeTotal: Scalars['BigDecimal']['output'];
    size: Scalars['BigDecimal']['output'];
    sizeTotal: Scalars['BigDecimal']['output'];
    realizedPnL: Scalars['BigDecimal']['output'];
    realizedPnLTotal: Scalars['BigDecimal']['output'];
    realizedPnLPercentage: Scalars['BigDecimal']['output'];
    realizedPnLPercentageTotal: Scalars['BigDecimal']['output'];
    wins: Scalars['BigDecimal']['output'];
    winsTotal: Scalars['BigDecimal']['output'];
    losses: Scalars['BigDecimal']['output'];
    lossesTotal: Scalars['BigDecimal']['output'];
};

export type LiquidityPoolData = {
    __typename?: 'LiquidityPoolData';
    id: Scalars['ID']['output'];
    dataPoint: DataPoint;
    liquidityPool: LiquidityPool;
    feeAmount: Scalars['BigDecimal']['output'];
    feeAmountTotal: Scalars['BigDecimal']['output'];
};

export enum DataType {
    UserReferralFeeAmount = 'USER_REFERRAL_FEE_AMOUNT',
    LiquidityPoolTotalValueLocked = 'LIQUIDITY_POOL_TOTAL_VALUE_LOCKED',
    TradePairTradingVolume = 'TRADE_PAIR_TRADING_VOLUME',
}

export type Data = {
    __typename?: 'Data';
    id: Scalars['ID']['output'];
    periodType: PeriodType;
    startTimestamp: Scalars['Int']['output'];
    type: DataType;
    parentId: Scalars['String']['output'];
    dataMapping: DataMapping;
    value: Scalars['BigDecimal']['output'];
    valueTotal: Scalars['BigDecimal']['output'];
};
